/* src/app/admin-dashboard/poweroffice-log/poweroffice-log.component.css */
.pol-wrap {
  padding: 16px;
}
.pol-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.pol-spacer {
  flex: 1 1 auto;
}
.pol-env {
  padding: 3px 10px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 12px;
  font-weight: 700;
}
.pol-env--prod {
  background: #fee2e2;
  color: #991b1b;
}
.pol-error {
  color: #b91c1c;
}
.pol-table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.pol-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.pol-table th {
  text-align: left;
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
}
.pol-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.pol-row {
  cursor: pointer;
}
.pol-row:hover {
  background: #f8fafc;
}
.pol-row--bad {
  background: #fef2f2;
}
.pol-nowrap {
  white-space: nowrap;
}
.pol-muted {
  color: #94a3b8;
}
.pol-small {
  font-size: 12px;
}
.pol-empty {
  text-align: center;
  padding: 24px;
}
.pol-actions {
  text-align: right;
  white-space: nowrap;
}
.pol-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  margin-right: 4px;
}
.pol-badge--ok {
  background: #dcfce7;
  color: #166534;
}
.pol-badge--bad {
  background: #fee2e2;
  color: #991b1b;
}
.pol-badge--warn {
  background: #fef3c7;
  color: #92400e;
}
.pol-badge--muted {
  background: #f1f5f9;
  color: #475569;
}
.pol-detail td {
  background: #f8fafc;
}
.pol-entry {
  padding: 6px 0;
  border-bottom: 1px dashed #e2e8f0;
}
.pol-entry:last-child {
  border-bottom: 0;
}
.pol-entry--bad .pol-entry-head {
  color: #991b1b;
}
.pol-mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 12.5px;
}
.pol-err {
  color: #b91c1c;
  font-size: 12.5px;
  margin-top: 2px;
  white-space: pre-wrap;
}
.pol-changes {
  margin-top: 4px;
  font-size: 12.5px;
}
.pol-changes td {
  padding: 1px 8px 1px 0;
  border: 0;
}
.pol-before {
  color: #94a3b8;
  text-decoration: line-through;
}
/*# sourceMappingURL=poweroffice-log.component.css.map */
